<template>
<div>
    <h1>Lyrics ({{ lyricsCount }})</h1>             

    <div class="md-form mt-0 row">
        <input class="form-control form-control-sm ml-3 w-25" type="text" placeholder="Search" aria-label="Search" v-model="keywords">
        <button class="btn btn-primary" type="submit" v-on:click="search">Search</button>        
    </div>
    <br/>
    <div class="overflow-auto">
        <b-pagination
            v-model="currentPage"
            :total-rows="lyricsCount"
            :per-page="lyricsByPage"
            :limit="10"
            @change="clickCallback">
        </b-pagination>
    </div>        
    <div v-bind:lyrics="lyrics">
        <table class="table">
            <tr>
                <th class="col-sm-1">Sync</th>
                <th class="col-sm-4" @click="sort('artist')">Artist</th>
                <th class="col-sm-4" @click="sort('title')">Title</th>
                <th class="col-sm-3" @click="sort('updateDateTime')">Update time</th>
            </tr>
            <tr v-for="lyric in lyrics" v-bind:key="lyric.id">                
                <td v-if="lyric.isSynchronized == true">X</td>
                <td v-if="lyric.isSynchronized == false"></td>
                <td><router-link :to="{ name: 'lyric', params: { id: lyric.id }}">{{ lyric.artist }}</router-link></td>
                <td><router-link :to="{ name: 'lyric', params: { id: lyric.id }}">{{ lyric.title }}</router-link></td>
                <td>{{ lyric.updateDateTime | formatDate }}</td>
            </tr>
        </table>
    </div>
</div>
</template>

<script>
    
    import ApiClient from '@/tools/apiClient.js';

    let api = new ApiClient();

    export default {
        name: 'lyrics',            
        data: function () {
            return {
                lyrics: [],
                lyricsCount: 0,                
                pageCount: 1,   
                lyricsByPage: 50,
                currentPage: 1,
                keywords: '',
                orderByField: "artist",
                orderBy: "ascending"
            }
        },

        created: async function () {
            this.lyricsCount = await api.getLyricsCountAsync();
            this.pageCount = this.lyricsCount / this.lyricsByPage;
            this.keywords = '';
            
            this.lyrics = await api.getLyricsAsync(this.keywords, this.orderByField, this.orderBy, 0, this.lyricsByPage);
        },

        methods: {
            clickCallback: async function(page) {           
                this.currentPage = page;
                var offset = (page - 1) * this.lyricsByPage;              
                
                this.lyrics = await api.getLyricsAsync(this.keywords, this.orderByField, this.orderBy, offset, this.lyricsByPage);
            },

            search: async function() {
                var offset = 0;
                this.currentPage = 1;
                                                    
                this.lyrics = await api.getLyricsAsync(this.keywords, this.orderByField, this.orderBy, offset, this.lyricsByPage);
                
                if(this.keywords == '')
                    this.lyricsCount = await api.getLyricsCountAsync();
                else
                    this.lyricsCount = this.lyrics.length;

                this.currentPage = 1;                
                this.pageCount = this.lyricsCount / this.lyricsByPage;                
            },

            sort: async function(field) {                
                if(field === this.orderByField) {
                    this.orderBy = this.orderBy === 'ascending' ? 'descending' : 'ascending';
                }

                this.orderByField = field;

                await this.search();
            }
        }
    }
</script>
